import React from "react";
import { Instagram, Twitter, Youtube } from "lucide-react";

export const Footer = ({ t }) => {
  return (
    <footer
      data-testid="site-footer"
      className="px-6 md:px-12 lg:px-16 pt-24 md:pt-32 pb-10 bg-[#0B0A09] text-[#F3EFE9]"
    >
      <div className="grid grid-cols-2 md:grid-cols-12 gap-12 mb-20">
        <div className="col-span-2 md:col-span-5">
          <p className="overline mb-5">KAFKAZSTYLE — Maison</p>
          <p className="font-serif text-2xl md:text-3xl text-[#F3EFE9] font-light leading-snug max-w-md">
            {t.footer.tagline}
          </p>
          <div className="flex gap-4 mt-8">
            <a href="#" data-testid="social-instagram" aria-label="Instagram"
               className="p-3 border border-[#3A342E] hover:border-[#A67A53] transition-colors">
              <Instagram size={16} strokeWidth={1.5} />
            </a>
            <a href="#" data-testid="social-twitter" aria-label="Twitter/X"
               className="p-3 border border-[#3A342E] hover:border-[#A67A53] transition-colors">
              <Twitter size={16} strokeWidth={1.5} />
            </a>
            <a href="#" data-testid="social-youtube" aria-label="YouTube"
               className="p-3 border border-[#3A342E] hover:border-[#A67A53] transition-colors">
              <Youtube size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="md:col-span-2 md:col-start-7">
          <p className="overline mb-5">{t.footer.sections.atelier}</p>
          <ul className="space-y-3 font-serif text-lg">
            {t.footer.sections.atelier_links.map((l) => (
              <li key={l}><a href="#" className="link-underline text-[#F3EFE9]">{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-5">{t.footer.sections.shop}</p>
          <ul className="space-y-3 font-serif text-lg">
            {t.footer.sections.shop_links.map((l) => (
              <li key={l}><a href="#" className="link-underline text-[#F3EFE9]">{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-5">{t.footer.sections.contact}</p>
          <ul className="space-y-3 font-mono text-sm">
            {t.footer.sections.contact_links.map((l) => (
              <li key={l} className="text-[#9D9287]">{l}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Massive brand wordmark */}
      <div
        data-testid="footer-wordmark"
        className="border-t border-[#3A342E] pt-10 overflow-hidden select-none"
      >
        <p
          className="font-serif font-light leading-none tracking-tight text-[#F3EFE9]/95"
          style={{ fontSize: "clamp(48px, 18vw, 280px)" }}
        >
          KAFKAZSTYLE
        </p>
      </div>

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mt-12 border-t border-[#3A342E] pt-8">
        <p className="overline">{t.footer.bottom}</p>
        <p className="overline">Made with quiet hands · Tbilisi → World</p>
      </div>
    </footer>
  );
};
